import { render } from "./HBEShopping.vue?vue&type=template&id=71826d6a&scoped=true"
import script from "./HBEShopping.vue?vue&type=script&lang=js"
export * from "./HBEShopping.vue?vue&type=script&lang=js"

import "./HBEShopping.vue?vue&type=style&index=0&id=71826d6a&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71826d6a"]])

export default __exports__